import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import TrainCompanyApi from './api'
import { ApiParams } from '../../types'

interface UseTrainCompaniesProps extends ApiParams {}

const useTrainCompanies = ({ filters }: UseTrainCompaniesProps) => {
  const { data: trainCompanies, isLoading: trainCompaniesIsLoading } = useQuery(
    [QUERY_KEYS.TRAIN_COMPANIES, filters],
    () => TrainCompanyApi.getAllByFilters({ filters }),
    {
      staleTime: Infinity,
    },
  )

  return {
    trainCompanies,
    trainCompaniesIsLoading,
  }
}

export default useTrainCompanies
